import React, { useMemo } from "react";
import Styles from "../../styles/sorting/SortingGraph.module.css";
import { MdPlayArrow, MdRefresh } from "react-icons/md";

const SortingGraphComponent = ({
  height,
  refresh,
  playAnimation,
}: {
  height: { height: number[]; si: number; ei: number };
  refresh: any;
  playAnimation: any;
}) => {
  return useMemo(
    () => (
      <div className={Styles.container}>
        <div className={Styles.btnContainer}>
          <div className={Styles.playButton} onClick={() => playAnimation()}>
            <MdPlayArrow size={25} color="#fff" />
          </div>
          <div className={Styles.playButton} onClick={() => refresh()}>
            <MdRefresh size={25} color="#fff" />
          </div>
        </div>
        {height.height.map((num: number, index) => (
          <div
            key={index}
            className={Styles.piller}
            style={{
              height: num * 3,
              backgroundColor:
                height.si === index || height.ei === index
                  ? "#398564"
                  : "#880088",
            }}
          >
            <p className={Styles.number}>{num}</p>
          </div>
        ))}
      </div>
    ),
    [height.ei, height.height, height.si, playAnimation, refresh]
  );
};

export default SortingGraphComponent;
